<div class="container-fluid">
    <div class="row">
        <div class="col-12">
            <div style="background: white; border: 1px solid #cacaca; border-radius: 5px;" id="container-images">
                <ngx-slick-carousel #slickModal class="carousel" [config]="slideConfig" style="padding: 0 10px;">
                    <div ngxSlickItem *ngFor="let item of dishes; let index = index" class="slide">
                        <div class="box_style_2 dish">
                            <div class="elements" style="display: flex; flex-direction: row;">
                                <div class="general" style="width: 90%;">
                                    <h2 class="inner">{{item.Nombre}}</h2>
                                    <div class="img" [ngStyle]="getBackgroundStyle(item.Foto)"></div>
                                </div>
                                <div class="info" style="width: 10%;">
                                    <img *ngIf="!item.Liked" src="./assets/img/heart.png" class="likedImg">
                                    <img *ngIf="item.Liked" src="./assets/img/heartLiked.png" class="likedImg">
                                </div>
                            </div>




                            <p>
                                {{item.Descripcion}}
                            </p>
                            <p class="price" *ngIf="currencyService.state$ | async as currencyState">
                                {{item.Precio | bravumCurrency:currencyState:i18n.locale}}
                            </p>
                            <div id="summary_review">
                                <div id="general_rating">
                                {{ 'menu.functionalQualities' | t }}


                                </div>
                                <div class="row" id="rating_summary">
                                    <div class="col-md-12">
                                        <table class="table table-dark table-striped" style="font-size: 11px;">
                                            <thead>
                                                <tr>
                                                    <th scope="col">{{ 'menu.quality' | t }}</th>
                                                    <th scope="col">{{ 'menu.unit' | t }}</th>
                                                    <th scope="col">{{ 'menu.value' | t }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let cualidad of item.descCualidades">
                                                    <td>{{ cualidad.Nombre }}</td>
                                                    <td>{{ cualidad.Desc | replaceNo }}</td>
                                                    <td>{{ cualidad.Valor }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>


                                </div><!-- End row -->

                            </div><!-- End summary_review -->


                        </div>
                    </div>
                </ngx-slick-carousel>
            </div>
        </div>
    </div>
</div>
